<div class="mobile-filter-panel">
  <fa-icon
    class="loader"
    [class.shown]="!(atlasMobileFilterService.atlasMobileService.isByzoneLoaded && atlasMobileFilterService.atlasMobileService.isDetailedLoaded)"
    [icon]="icons.falSpinnerThird"
    animation="spin"
  ></fa-icon>

  @if (atlasMobileFilterService.atlasMobileService.isByzoneLoaded && atlasMobileFilterService.atlasMobileService.isDetailedLoaded) {
    <div class="mobile-filter-content">
      <div class="filters compact-filters">
        <div class="datasets compact-datasets">
          @for (entry of olMapService.datasets; track entry) {
            <div
              class="dataset"
              [class.active]="olMapService.dataset === entry.dataset"
              (click)="changeDataset(entry)"
              id="{{ entry.label }}"
            >
              {{ entry.label | translate }}
            </div>
          }
        </div>

        <app-area-select
          class="mobile-area-search"
          [(selectedArea)]="selectedArea"
          (selectedAreaChange)="onSearchArea($event)"
        ></app-area-select>

        <div class="mobile-filter-list">
          @for (fil of olMapService.filters; track fil) {
            <div class="mobile-filter-control">
              <app-atlas-filter-field
                [label]="fil.label"
                [value]="olMapService.filter.get(fil.key)"
                [multiple]="fil.multiple"
                [compact]="isByzoneSelected"
                [choices]="fil.choices"
                (valueChange)="setFilter(fil.key, $event)"
              ></app-atlas-filter-field>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>